<div class="container">
  <h2>All Proforma Invoices</h2>
  <table class="proforma-table">
    <thead>
      <tr>
        <th>ID</th>
        <th>Buyer</th>
        <th>Phone</th>
        <th>Status</th>
        <th>Total</th>
        <th>Items</th>
        <th>PDF</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let proforma of paginatedProformas">
        <td>{{ proforma.id }}</td>
        <td>{{ proforma.buyerName }}</td>
        <td>{{ proforma.buyerPhoneNumber }}</td>
        <td>{{ proforma.status }}</td>
        <td>₹{{ proforma.totalAmount | number : "1.2-2" }}</td>
        <td>{{ proforma.numberOfItems }}</td>
        <td><a [href]="proforma.linkToPdf" target="_blank">PDF</a></td>
        <td>
          <button (click)="viewDetails(proforma.id)" class="btn btn-primary">
            View
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="selectedProforma" class="details-section">
    <div class="d-flex justify-content-between">
      <h3>Proforma Details - ID {{ selectedProforma.id }}</h3>
      <button (click)="closeDetails()" class="btn btn-danger">Close</button>
    </div>

    <div class="d-flex col-6 justify-content-between">
      <label>Buyer Name:</label>
      <input [(ngModel)]="selectedProforma.buyerName" [readonly]="!isEditing" />
    </div>

    <div class="d-flex col-6 justify-content-between">
      <label>Phone Number:</label>
      <input
        [(ngModel)]="selectedProforma.buyerPhoneNumber"
        [readonly]="!isEditing"
      />
    </div>

    <div class="d-flex col-6 justify-content-between">
      <label>GST Number:</label>
      <input [(ngModel)]="selectedProforma.buyerGst" [readonly]="!isEditing" />
    </div>

    <div class="d-flex col-6 justify-content-between">
      <label>Status:</label>
      <select [(ngModel)]="selectedProforma.status" [disabled]="!isEditing">
        <option value="Active">Active</option>
        <option value="Draft">Draft</option>
        <option value="Ordered">Ordered</option>
        <option value="Cancelled">Cancelled</option>
      </select>
    </div>
    <div class="actions my-3">
      <button *ngIf="!isEditing" (click)="enableEdit()" class="btn btn-info">
        Edit
      </button>
      <button *ngIf="isEditing" (click)="saveChanges()" class="btn btn-success">
        Save
      </button>
      <button *ngIf="isEditing" (click)="cancelEdit()" class="btn btn-danger">
        Cancel
      </button>
    </div>
    <div class="d-flex justify-content-between border-primary py-3 px-3">
      <h4 class="text-center">Invoice Items</h4>
      <button
        (click)="showItems = true"
        *ngIf="!showItems"
        class="btn btn-primary"
      >
        Show Items
      </button>
      <button
        (click)="showItems = false"
        *ngIf="showItems"
        class="btn btn-primary"
      >
        Hide Items
      </button>
    </div>
    <table class="items-table" *ngIf="showItems">
      <thead>
        <tr>
          <th>Product</th>
          <th>HSN</th>
          <th>Qty</th>
          <th>MRP</th>
          <th>Offer</th>
          <th>Tax %</th>
          <th>Final</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of selectedProforma.items">
          <td>{{ item.productName }}</td>
          <td>{{ item.hsnCode }}</td>
          <td>{{ item.quantity }}</td>
          <td>₹{{ item.mrp }}</td>
          <td>₹{{ item.offerPrice | number : "1.2-2" }}</td>
          <td>{{ item.taxRate }}%</td>
          <td>₹{{ item.finalPrice | number : "1.2-2" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Pagination Controls -->
  <div class="pagination-controls text-center d-flex justify-content-center">
    <button
      (click)="setPage(currentPage - 1)"
      [disabled]="currentPage === 1"
      class="btn btn-primary"
    >
      Prev
    </button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button
      (click)="setPage(currentPage + 1)"
      [disabled]="currentPage === totalPages"
      class="btn btn-primary"
    >
      Next
    </button>
  </div>
</div>
